import { isAmlGuidelineCharge } from "../constants/guidelineCharges";

const emailKey = (value) => String(value || "").trim().toLowerCase();
const chargeKey = (value) => String(value || "")
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, "");
const isAmlCharge = (record = {}) =>
  isAmlGuidelineCharge(record) ||
  [record.chargeType, record.manualChargeType]
    .some((value) => chargeKey(value) === "amlchecks");

export const applyAmlPaymentExceptions = (
  records = [],
  exceptionEmails = [],
) => {
  const exceptions = new Set(exceptionEmails.map(emailKey).filter(Boolean));
  if (!exceptions.size) return records;

  return records.map((record) => {
    if (
      !exceptions.has(emailKey(record.adviserEmail)) ||
      !isAmlCharge(record)
    ) {
      return record;
    }

    return {
      ...record,
      originalChargeType: record.chargeType,
      originalChargeTypeId: record.chargeTypeId,
      originalManualChargeType: record.manualChargeType,
      originalManualChargeTypeId: record.manualChargeTypeId,
      chargeType: "Payments",
      chargeTypeId: "",
      manualChargeType: "AML Payment",
      manualChargeTypeId: "",
      isAmlPaymentException: true,
      excludeFromBalance: true,
    };
  });
};
